<template>
  <OLink ref="elRef" pure :href="item.url" class="flex items-center text-white p-2" @click="clickEvent()">
    <OImage :src="item.image.resolutions.standard.url" class="w-[106px] h-15 rounded object-cover flex-shrink-0" />
    <p class="text-13 line-clamp-3 ml-2 font-semibold">
      {{ item.title }}
    </p>
  </OLink>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { OLink, OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink, OImage },
  props: {
    item: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
    },
  },
  setup(props) {
    // Data Layer Impression & Click
    const { sendDataLayer } = useTracking();
    const { elRef, clickEvent } = sendDataLayer(
      {
        item: props.item,
        list: 'Video Detay - Önerilen Videolar',
        position: parseInt(props.index) + 1,
      },
      ['scroll', 'click']
    );
    return { elRef, clickEvent };
  },
});
</script>
